<template>
  <div>
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == false">
      <b-card no-body>
        <b-card-header header-bg-variant="light" header-border-variant="secondary">
          <h4>
            <feather-icon icon="StarIcon"/>
            ข้อตกลงการแจ้งออกของ
          </h4>
        </b-card-header>
        <b-card-body body-border-variant="secondary" >
          <b-card class="mt-2" border-variant="danger" no-body>
            <ul class="pt-1 ml-0">
              <li class="pb-1" v-for="item in agreement" :key="item.orderNo">
                {{item.description}}
              </li>
            </ul>
          </b-card>
        </b-card-body>
      </b-card>
      <b-card no-body id="track">
        <b-card-header header-bg-variant="light" header-border-variant="secondary">
          <h4>
            <feather-icon icon="StarIcon"/>
            1. เลือกรายการ
          </h4>
        </b-card-header>
        <!-- pc -->
        <b-card-body class="pt-1 d-none d-sm-block" body-border-variant="secondary">
          <div v-if="this.valTracking == false" style="color:red">กรุณาเลือกรายการ</div>
          <b-table
            responsive
            :items="trackInfos"
            :fields="trackFields"
            selectedVariant="success"
            small
            style="width:100%"
          >
            <template v-slot:head(rowID)>
              <b-form-checkbox
                v-model="selAllTracking"
                @change="selectAllTracking()"
                :disabled="trackInfos.length == 0"
              />
            </template>
            <template #cell(rowID)="data">
              <b-form-checkbox v-model="selTracking" :value="data.item" @change="selectTracking()">
              </b-form-checkbox>
            </template>
            <template #cell(receiveDate)="data">
              {{formatDatetime(data.value)}}
            </template>
            <template #cell(weight)="data">
              <div v-if="data.item.weight != null">
                {{format_price(data.value)}}
              </div>
            </template>
            <template #cell(cubic)="data">
              <div v-if="data.item.cubic != null">
                {{format_decimal(data.value)}}
              </div>
            </template>
            <template #cell(offChinaDate)="data">
              {{formatDatetime(data.value)}}
            </template>
            <template #cell(arrivedThaiDate)="data">
              {{formatDatetime(data.value)}}
            </template>
          </b-table>
          <b-row class="pt-1" >
            <b-col class="pr-0 col-md-2">
              <div>เลือกรวม</div>
            </b-col>
            <b-col class="pl-0 col-md-2">
              <div class="text-right">{{this.sumSelected}}</div>
            </b-col>
            <b-col class="px-0 col-md-2">
              <div>ชิ้น</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0 col-md-2">
              <div>น้ำหนักรวม</div>
            </b-col>
            <b-col class="pl-0 col-md-2">
              <div class="text-right">{{format_price(this.sumWieght)}}</div>
            </b-col>
            <b-col class="px-0 col-md-2">
              <div>กิโลกรัม</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pr-0 col-md-2">
              <div>ขนาดรวม</div>
            </b-col>
            <b-col class="pl-0 col-md-2" >
              <div class="text-right">{{format_decimal(this.sumCubic)}}</div>
            </b-col>
            <b-col class="px-0 col-md-2">
              <div>คิว</div>
            </b-col>
          </b-row>
        </b-card-body>
        <!-- mobile -->
        <b-card-body class="pt-1 d-none d-block d-sm-none" body-border-variant="secondary">
          <div class="d-flex">
            <b-form-checkbox
              v-model="selAllTracking"
              class="pr-1"
              @change="selectAllTracking()"
              :disabled="this.trackInfos.length == 0"
            >
              เลือกทั้งหมด
            </b-form-checkbox>
            <div v-if="this.valTracking == false" style="color:red">กรุณาเลือกรายการ</div>
          </div>
          <hr class="dense">
          <div v-for="(item, index) in trackInfos" :key="index">
            <b-row class="pl-1" role="tablist">
              <b-col cols="1">
                <b-form-checkbox v-model="selTracking" :value="item" @change="selectTracking()"/>
              </b-col>
              <b-col role="tab">
                <h5>{{item.trackingNo}}</h5>
                <div v-if="item.remark">{{item.remark}}</div>
                <div>
                  <span>{{format_price(item.weight)}} kg, {{format_decimal(item.cubic)}} คิว</span>
                  <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="btn-icon rounded-circle float-right"
                    v-b-toggle="'list-'+index"
                  >
                    <span class="when-opened">
                      <feather-icon icon="ChevronUpIcon" />
                    </span>
                    <span class="when-closed">
                      <feather-icon icon="ChevronDownIcon" />
                    </span>
                  </b-button>
                </div>
                <b-collapse class="pt-1" :id="'list-'+index" accordion="list" role="tabpanel">
                  <div>รับเข้าจีน : {{formatDatetime(item.receiveDate)}}</div>
                  <div>ออกจากจีน : {{formatDatetime(item.offChinaDate)}}</div>
                  <div>เข้าโกดังไทย : {{formatDatetime(item.arrivedThaiDate)}}</div>
                </b-collapse>
              </b-col>
            </b-row>
            <hr class="dense pl-0">
          </div>
          <div>เลือกรวม : {{this.sumSelected}} ชิ้น</div>
          <div>น้ำหนักรวม : {{format_price(this.sumWieght)}} กิโลกรัม</div>
          <div>ขนาดรวม : {{format_decimal(this.sumCubic)}} คิว</div>
        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-card-header header-bg-variant="light" header-border-variant="secondary">
          <h4>
            <feather-icon icon="StarIcon"/>
            2. เลือกรูปแบบ-จัดส่ง
          </h4>
        </b-card-header>
        <b-card-body class="pt-1" body-border-variant="secondary">

          <b-form>
            <b-row class="px-md-1">
              <b-col cols="12" class="pb-1">
                <b-form-group label="จัดส่งโดย :" label-cols-md="2">
                  <div v-if="this.valDomestic == false" style="color:red">กรุณาเลือกรูปแบบการส่ง</div>
                  <b-form-radio-group v-model="domestic" stacked>
                    <b-form-radio :value="domesticTypesPackhai[0]" class="pb-1">
                      {{this.domesticTypesPackhai[0].description}}<b-link href="https://lin.ee/fbDRpjC/" target="_blank">https://lin.ee/fbDRpjC</b-link>
                    </b-form-radio>
                    <div v-for="item in domesticTypes" :key="item.length" class="pb-1" id="other">
                      <b-form-radio :value="item">
                        {{item.description}}
                      </b-form-radio>
                    </div>
                  </b-form-radio-group>
                  <div v-if="this.domestic.rowId == 11">
                    <div v-if="this.valDomesticOther == false" style="color:red">กรุณาระบุขนส่ง</div>
                    <div class="d-flex align-items-center">
                      <span class="pr-1" style="color:blue">โปรดระบุ -> </span>
                      <b-form-input v-model="otherTrans" class="col-5"></b-form-input>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pb-2">
                <b-form-group label="จัดส่งในนาม :" label-cols-md="2">
                  <b-form-radio-group
                    v-model="senderAddressId"
                    stacked
                  >
                    <b-form-radio :value="0" class="pb-1">Taobao2you</b-form-radio>
                    <div v-for="item in senderAddressList" :key="item.length" class="pb-1">
                      <b-form-radio  :value="item.addressID">
                        {{item.addressText}}
                      </b-form-radio>
                    </div>
                  </b-form-radio-group>
                  <b-button
                    variant="primary"
                    size="sm"
                    v-b-modal.sender-address
                  >เพิ่มที่อยู่จัดส่งในนามใหม่</b-button>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pb-2">
                <b-form-group label="ที่อยู่จัดส่ง :" label-cols-md="2">
                  <b-form-radio-group
                    v-model="cusAddressId"
                    stacked
                  >
                    <div v-for="item in cusAddressList" :key="item.length" class="pb-1">
                      <b-form-radio  :value="item.addressID">
                        {{item.addressText}}
                      </b-form-radio>
                    </div>
                  </b-form-radio-group>
                  <b-button
                    variant="primary"
                    size="sm"
                    v-b-modal.customer-address
                  >เพิ่มที่อยู่ใหม่</b-button>
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pb-2" id="request">
                <b-form-group label="ต้องการ :" label-cols-md="2">
                  <div v-if="this.valRequest == false" style="color:red">กรุณาเลือก</div>
                  <b-form-radio-group
                    v-model="selRequest"
                    :options="request"
                    name="radio-validation"
                    stacked
                  >
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="หมายเหตุ :" label-cols-md="2">
                  <b-form-textarea v-model="remark" class="col-md-6" rows="3"/>
                  <div class="pt-1" style="color:red">**หากแจ้งออกของต่อบิลไม่ถึง 3 กิโลจะมีค่าบริการเพิ่มเติม 20 บาท ต่อบิล</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer footer-bg-variant="light" footer-border-variant="secondary">
          <b-button
            variant="danger"
            @click="btnInform()"
            :disabled="this.loadButton == false"
          >
            <b-spinner v-if="this.loadButton == false" small />
            แจ้งออกของ
          </b-button>
        </b-card-footer>
      </b-card>

      <!-- modal customer address-->
      <b-modal
        id="customer-address"
        ref="customer-address"
        title="เพิ่มที่อยู่ผู้รับ"
        @hidden="closePopup"
        no-close-on-backdrop
        centered
        no-close-on-esc
        hide-footer
      >
        <b-form>
          <b-form-group>
            <label >ชื่อผู้รับ :</label>
            <b-form-input v-model="nameAddress"/>
            <span class="float-right textVal" v-if="this.valName == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-group>
            <label >เบอร์โทร :</label>
            <b-form-input v-model="telAddress"/>
            <span class="float-right textVal" v-if="this.valTel == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-group>
            <label >ที่อยู่ :</label>
            <b-form-Textarea v-model="address"/>
            <span class="float-right textVal" v-if="this.valAddress == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-group>
            <label >รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :</label>
            <v-select
              v-model="selCustomerPostcode"
              :options="postcodeMapping"
              label="list"
            >
            </v-select>
            <span class="float-right textVal" v-if="this.valPostcode == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-checkbox
            v-model="defaultCusAddress"
            :value="true"
            :unchecked-value="false"
          >
            ใช้เป็นที่อยู่จัดส่งหลัก
          </b-form-checkbox>
          <div class="float-right d-flex pt-1">
            <b-button variant="outline-danger" @click="closePopup">ยกเลิก</b-button>
            <b-button
              class="ml-1"
              variant="primary"
              @click="addCustomerAddress"
              :disabled="this.loadBtnAddress == false"
            >
              <b-spinner v-if="this.loadBtnAddress == false" small />
              บันทึกที่อยู่
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- modal sender address-->
      <b-modal
        id="sender-address"
        ref="sender-address"
        title="เพิ่มที่อยู่ในนาม"
        @hidden="closePopup"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
      >
        <b-form>
          <b-form-group>
            <label >ส่งในนาม :</label>
            <b-form-input v-model="nameAddress"/>
            <span class="float-right textVal" v-if="this.valName == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-group>
            <label >เบอร์โทร :</label>
            <b-form-input v-model="telAddress"/>
            <span class="float-right textVal" v-if="this.valTel == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-group>
            <label >ที่อยู่ :</label>
            <b-form-Textarea v-model="address"/>
            <span class="float-right textVal" v-if="this.valAddress == false">กรุณาระบุ</span>
          </b-form-group>
          <b-form-group>
            <label >รหัสไปรษณีย์/ตำบล/อำเภอ/จังหวัด :</label>
            <v-select
              v-model="selSenderPostcode"
              :options="postcodeMapping"
              label="list"
            >
            </v-select>
            <span class="float-right textVal" v-if="this.valPostcode == false">กรุณาระบุ</span>
          </b-form-group>
          <div class="float-right d-flex pt-1">
            <b-button variant="outline-danger" @click="closePopup">ยกเลิก</b-button>
            <b-button
              class="ml-1"
              variant="primary"
              @click="addSenderAddress"
              :disabled="this.loadBtnAddress == false"
            >
              <b-spinner v-if="this.loadBtnAddress == false" small />
              บันทึกที่อยู่
            </b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, BFormRadio, BCardFooter, BModal, VBModal, BForm,
  VBToggle, BCollapse,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
import { format_price, formatDatetime, format_decimal } from '@/views/global_function.js'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },

  components: {
    BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
    BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
    BFormCheckbox, BFormTextarea, BLink, BCardHeader, flatPickr, BFormRadio, BCardFooter, BModal,
    BForm, VBModal, vSelect, ToastificationContent, VBToggle, BCollapse
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      date: new Date().fp_incr(-10),
      dueDate: new Date(),
      agreement: [],
      trackInfos: [],
      trackFields: [
        { key: 'rowID', label: 'selected', thStyle: { width: "2%" }, },
        { key: 'trackingNo', label: 'TrackingNo'},
        { key: 'weight', label: 'น้ำหนัก(kg)' },
        { key: 'cubic', label: 'ขนาด', thStyle: { width: "5%" }, },
        { key: 'remark', label: 'หมายเหตุ'},
        { key: 'receiveDate', label: 'รับเข้าโกดังจีน'},
        { key: 'offChinaDate', label: 'ออกจากจีน'},
        { key: 'arrivedThaiDate', label: 'ถึงไทย'},
      ],
      selTracking: [],
      selAllTracking: false,
      sumSelected: 0,
      sumWieght: 0,
      sumCubic: 0,

      domestic: [],
      domesticTypes: [],
      domesticTypesPackhai: [],
      cusAddressList: [],
      senderAddressList: [],
      cusAddressId: null,
      senderAddressId: null,
      selRequest: null,
      request: [
        { text: 'ออกเฉพาะรายการที่เลือกเท่านั้น', value: true },
        { text: 'แพ็คของชิ้นอื่นด้วยหากมีมาเพิ่ม', value: false },
      ],
      remark: '',
      descriptionTrans: '',
      otherTrans: '',

      valTracking: true,
      valDomestic: true,
      valRequest: true,
      valDomesticOther: true,

      nameAddress: '',
      telAddress: '',
      address: '',
      postcodeMapping: [],
      selCustomerPostcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', rowID: 0},
      selSenderPostcode: { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', rowID: 0},
      defaultCusAddress: false,
      defaultSenderAddress: false,
      valName: true,
      valTel: true,
      valAddress: true,
      valPostcode: true,

      loadpage: true,
      loadButton: true,
      loadBtnAddress: true,
    };
  },

  async created() {
    await this.loadRequestPage()
    await this.getPostcode()
    var list = await JSON.parse(localStorage.getItem('allTrackingShipping'))
    if (list != null && list.length != 0) {
      await this.trackInfos.forEach( e => {
        if (list.filter( x => x == e.rowID).length > 0) {
          this.selTracking.push(e)
        }
      });
      if (this.selTracking.length == this.trackInfos.length) {
        this.selAllTracking = true
      }
    }
    localStorage.removeItem('allTrackingShipping')
  },

  watch: {
    async domestic() {
      if( this.domestic.rowId != 11){
      this.descriptionTrans = this.domestic.description
      } else {
        this.descriptionTrans = this.otherTrans
      }
    },
    async otherTrans () {
      this.descriptionTrans = this.otherTrans
    },
    async selTracking () {
      if ( this.selTracking.length != 0) {
        this.sumSelected = this.selTracking.length
        this.sumWieght = await this.selTracking.map(i => Number(i.weight == null ? 0 : i.weight)).reduce((a, b) => a + b)
        this.sumCubic = await this.selTracking.map(i => Number(i.cubic == null ? 0 : i.cubic)).reduce((a, b) => a + b)
      } else {
        this.sumSelected = 0
        this.sumWieght = 0
        this.sumCubic = 0
      }
    }
  },

  methods: {
    format_price,
    formatDatetime,
    format_decimal,
    async loadRequestPage() {
      var keepdata= []
      var axios = require('axios');
      var data = JSON.stringify({
        "customerID": JSON.parse(localStorage.getItem('cusId')),
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Request/load-request-page',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.agreement = keepdata.agreementResponses
      this.trackInfos = keepdata.requestTrackings
      // this.domesticTypes = keepdata.domesticTypes
      keepdata.domesticTypes.forEach((e) => {
        if (e.code == 'PACKHAI') {
          var text = e.description.split('<a href=\"https://lin.ee/fbDRpjC\" target=\"_blank\">https://lin.ee/fbDRpjC</a>')
          this.domesticTypesPackhai.push({
            rowId: e.rowId,
            description: text[0]
          })
        } else {
          this.domesticTypes.push(e)
        }
      })
      this.cusAddressList = keepdata.customerAddresses
      this.senderAddressList = keepdata.senderAddresses
      this.cusAddressList.forEach((e) => {
        if( e.addressID == keepdata.defaultCustomerAddress.addressID ) {
          this.cusAddressId = e.addressID
        }
      })
     this.senderAddressId = 0
     this.loadpage= false
    },
    selectAllTracking() {
      if (this.selAllTracking == true) {
        this.selTracking = this.trackInfos
      } else {
        this.selTracking = []
      }
    },
    selectTracking() {
      if ( this.selTracking.length == this.trackInfos.length ) {
        this.selAllTracking = true
      } else {
        this.selAllTracking = false
      }
    },
    async btnInform() {
      if (this.selTracking.length == 0 || this.domestic.length == 0 || this.selRequest == null) {
        if(this.selTracking.length == 0) {
          this.valTracking = false
          document.getElementById('track').scrollIntoView();
        }
        if(this.domestic.length == 0) {
          this.valDomestic = false
          document.getElementById('track').scrollIntoView();
        }
        if(this.selRequest == null)
        this.valRequest = false
      } else if (this.domestic.rowId == 11 && this.otherTrans == '') {
        this.valDomesticOther = false
        document.getElementById('other').scrollIntoView();
      } else {
        this.loadButton = false
        var requestTracking = []
        await this.selTracking.forEach((e) => {
          requestTracking .push({
            "rowID": e.rowID,
            "trackingNo": e.trackingNo,
            "remark": e.remark,
            "receiveDate": e.receiveDate,
            "offChinaDate": e.offChinaDate,
            "expectedArrival": e.expectedArrival,
            "arrivedThaiDate": e.arrivedThaiDate,
            "isRequest": e.request
          })
        })
        var keepdata = []
        var axios = require('axios');
        var data = JSON.stringify({
          "requestTracking": requestTracking,
          "domesticID": this.domestic.rowId,
          "domesticText": this.descriptionTrans,
          "addressID": this.cusAddressId,
          "senderID": this.senderAddressId,
          "isOnlyRequest": this.selRequest,
          "remark": this.remark,
          "customerID":JSON.parse(localStorage.getItem('cusId'))
        });
        var config = {
          method: 'post',
          url: taobaoService_dotnet + 'app/Request/add-request',
          headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
            'Content-Type': 'application/json'
          },
          data : data
        };
        await axios(config)
        .then(function (response) {
          keepdata = response.data
        })
        .catch(function (error) {
          console.log(error);
        });
        if (keepdata == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งออกของเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.$router.push({path: '/customer-shipping/status'})
        }
        this.loadButton = true
      }
    },
    async addCustomerAddress(){
      this.loadBtnAddress = false
      if (this.nameAddress == '') {
        this.valName = false
      } else if(this.telAddress == '') {
        this.valTel = false
      } else if(this.address == '') {
        this.valAddress = false
      } else if (this.selCustomerPostcode == null || this.selCustomerPostcode.rowID == 0) {
        this.valPostcode = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Customer/add-customer-address',
          {
            // 'customerID': 1,
            'loginToken': this.userData.data.customerInfo.loginToken,
            'name': this.nameAddress,
            'phone': this.telAddress,
            'address': this.address,
            'tambon': this.selCustomerPostcode.subDistrict,
            'amphoe': this.selCustomerPostcode.district,
            'provinceID': this.selCustomerPostcode.provinceID,
            'province': this.selCustomerPostcode.province,
            'postcode': this.selCustomerPostcode.postcode,
            'postcodeMappingID': this.selCustomerPostcode.rowID,
            'isDefault': this.defaultCusAddress
          },
          { headers: header_token }
        );
        this.loadRequestPage()
        this.closePopup()
      }
      this.loadBtnAddress = true
    },
    async addSenderAddress(){
      this.loadBtnAddress = false
      if (this.nameAddress == '') {
        // bvModalEvt.preventDefault()
        this.valName = false
      } else if(this.telAddress == '') {
        this.valTel = false
      } else if(this.address == '') {
        this.valAddress = false
      } else if (this.selSenderPostcode == null || this.selSenderPostcode.rowID == 0) {
        this.valPostcode = false
      } else {
        let response = await axios.post(
          taobaoService_dotnet + 'app/Customer/add-sender-address',
          {
            'loginToken': this.userData.data.customerInfo.loginToken,
            'name': this.nameAddress,
            'phone': this.telAddress,
            'address': this.address,
            'tambon': this.selSenderPostcode.subDistrict,
            'amphoe': this.selSenderPostcode.district,
            'provinceID': this.selSenderPostcode.provinceID,
            'province': this.selSenderPostcode.province,
            'postcode': this.selSenderPostcode.postcode,
            'postcodeMappingID': this.selSenderPostcode.rowID,
            'isDefault': true,
            'isReceiver': false
          },
          { headers: header_token }
        );
        this.loadRequestPage()
        this.closePopup()
      }
      this.loadBtnAddress = true
    },

    closePopup() {
      this.nameAddress = ''
      this.telAddress = ''
      this.address = ''
      this.selCustomerPostcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', rowID: 0}
      this.defaultCusAddress = false
      this.selSenderPostcode = { list: '--รหัสไปรษณีย์ ตำบล อำเภอ จังหวัด--', rowID: 0}
      this.defaultSenderAddress = false
      this.valName = true
      this.valTel = true
      this.valAddress = true
      this.valPostcode = true
      this.$refs['customer-address'].hide()
      this.$refs['sender-address'].hide()
    },

    async getPostcode(){
      if (this.postcodeMapping.length == 0) {
        let response = await axios.get(
          taobaoService_dotnet + 'app/Customer/get-postcode-mapping',
          { headers: header_token }
        );
        response.data.forEach((e) => {
          this.postcodeMapping.push(
            {
              'list': e.postcode + " / " + e.subDistrict + " / " + e.district + " / " + e.province,
              'provinceID': e.provinceID,
              'rowID': e.rowID,
              'subDistrict': e.subDistrict,
              'district': e.district,
              'province': e.province,
              'postcode': e.postcode,

            }
          )
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  ul {
    list-style-type: decimal;
  }
  .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
      display: none;
    }
</style>
